import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { IMAGE_GEEKO_LTD } from '../../constants/index'
import Cache from '../../utils/cache'
import { withRouter } from 'react-router-dom'
import qs from 'query-string'
import { fetchLuckDrawTasks } from '../../api'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { useSelector, useDispatch } from 'react-redux'
import { setRaffle, setShowRaffle } from '../../store/actions/global'
import { BlackMask } from '../components/mask'
import { Iconfont } from '../components/icon/iconfont'


export const RaffleAlert = props => {
    useStyles(classes)

    const dispatch = useDispatch()

    return <div className={classes.RaffleAlert}>
        <Iconfont onClick={() => {
            dispatch(setShowRaffle(false))
        }} className={classes.Close}>&#xe7c8;</Iconfont>
        <img className={classes.Image} src={`${IMAGE_GEEKO_LTD}/2021-11-01-lottery/2021-11-10-jiugongge-mask-chances.png`} />
        <div className={classes.Bd}>
            <div className={classes.Title}>Congratulations</div>
            <div className={classes.Desc}>1 chance</div>
            <div>
                <button onClick={() => {
                    window.location.href='/i/lottery-black-friday'
                }} className={classes.RedButton}>Got it</button>
                <button onClick={() => {
                    dispatch(setShowRaffle(false))
                }} className={classes.BlackButton}>Keep Viewing</button>
            </div>
        </div>
    </div>
}



export default withRouter(props => {

    useStyles(classes)

    const dispatch = useDispatch()

    const global = useSelector((state) => state.global)

    const { raffle, showRaffle } = global

    const { location } = props

    const query = qs.parse(location?.search)

    const [drawTask, setDrawTask] = useState()

    useEffect(async () => {
        const key = query.promotionType
        if (key) {
            const task = await fetchLuckDrawTasks().then(data => data.result?.find?.(l => l.id === '02')).catch(data => { return null })
            const storedRaffle = Cache.get(key)

            if (task && task.rule) {
                setDrawTask(task)

                if (!storedRaffle) {
                    Cache.set(key, {
                        currentCount: 0,
                        currentCompletedTimes: 0,
                        task
                    })

                    dispatch(setRaffle({
                        currentCount: 0,
                        currentCompletedTimes: 0,
                        task
                    }))

                } else {
                    if (task?.maxCompletedTimes > storedRaffle?.currentCompletedTimes) {
                        Cache.set(key, {
                            ...storedRaffle,
                            task
                        })
                        dispatch(setRaffle({
                            ...storedRaffle,
                            task
                        }))
                    }
                }
            }
        }

    }, [])




    return <React.Fragment>
        {
            raffle && raffle.currentCompletedTimes < raffle?.task.maxCompletedTimes && <div className={classes.FixedRaffle}>
                <img className={classes.Image} src={`${IMAGE_GEEKO_LTD}/2021-11-01-lottery/2021-11-10-jiugongge-product-add.png`} />
                <div className={classes.Count}>
                    <span>{`${raffle?.currentCount || 0}/${raffle?.task?.rule?.addToCartTimes}`}</span>
                </div>
            </div>
        }

        {
            showRaffle && ReactDOM.createPortal(<React.Fragment>
                <BlackMask />
                <RaffleAlert />
            </React.Fragment>, document.getElementById('root'))
        }


    </React.Fragment>



})